import { AutoComplete } from "antd";
import { useEffect, useState } from "react";
import CategoriesApi from "../api/CategoriesApi";
import { CategoryDto } from "../generated/dashboard-client";
import { SearchOutlined } from "@ant-design/icons";
import "./SearchCategories.scss";

const { Option } = AutoComplete;

function getCategoryUrl(name: string) {
  name = name.replace(/\s+/g, "-");
  name = name.replace(/'/g, "%27");
  return `/category/${name}.html`;
}

export default function SearchCategories() {
  const [categories, setCategories] = useState([] as CategoryDto[]);

  useEffect(() => {
    CategoriesApi.getSearchableCategories().then((resp) => {
      let cats = [] as CategoryDto[];
      resp.data.forEach(
        (it) => {
          if (!cats.map(cat => cat.id).includes(it.id)) {
            cats.push(it);
          }
        }
      )
      setCategories(cats);
    });
  }, []);

  function onSelect(name: string) {
    window.location.href = getCategoryUrl(name);
  }

  function onSearch(txt: string) {
    const query = txt.toLowerCase();
    categories.forEach(
      (it) => (it.visible = it.name!.toLowerCase().indexOf(query) > -1)
    );
    setCategories([...categories]);
  }

  function onKeyUp(ev: any) {
    if (ev.code === "Enter") {
      const key = ev.target.value.replaceAll(" ", "-");
      window.location.href = `/template/${key}.html`;
    }
  }

  return (
    <div className={"search-categories"}>
      <AutoComplete
        size={"large"}
        placeholder={"Search 25,000 templates"}
        onSearch={onSearch}
        onSelect={onSelect}
        onKeyUp={onKeyUp}
      >
        {categories
          .filter((it) => it.visible)
          .map((it) => (
            <Option key={it.id} value={it.name}>
              {it.name}
            </Option>
          ))}
      </AutoComplete>
      <SearchOutlined />
    </div>
  );
}
